import { render, staticRenderFns } from "./HIPAAContacts.vue?vue&type=template&id=3a8b4a8a&scoped=true"
import script from "./HIPAAContacts.vue?vue&type=script&lang=js"
export * from "./HIPAAContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8b4a8a",
  null
  
)

export default component.exports